// 調整班表
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import '../../../scss/components/pages/edit_staff_shift.scss';
import Calendar from '../../Calendar';
import HourCostChart from '../../HourCostChart';
import moment from 'moment';
//import DayPickerList from '../../DayPickerList';
import API from '../../../middleware/API';
import {GetStoreRole} from '../../../const/constant';
import FileUploader from '../../FileUploader';

import {
  getDailyCostByHourDetail,
  getAllStaff,
  getHourCostChart,
  get30MinCostChart,
  get30MinBarCostChart,
  getAccumulateCostChart,
  peopleStatisticsList,
  InitAPIStatus,
} from '../../../store/action';
import swal from 'sweetalert2';
import { combineReducers } from 'redux';

class DailyCostByHour extends Component {
  constructor(props) {
    super(props);
    this.state = {
      calendarConfig: {
        defaultView: "agendaDay",
        draggable: false,
        isEventClick: false,
        isDayClick: false,
        header: {
          left: 'title',
          center: '',
          right: 'promptResource printbtn',
        },
      },
      currentDay:'',
      selectedFile: null,
      resources: [],
      events: [],
      costs: [],
      peoples: {},
      halfPeoples:{},
      accumulateCost: {
        income:0.0,
        outcome:0.0,
        expectOutcome:0.0
      },
      department: '-1',
      isAddStaffBlockOpen: false,
      isEditBlockOpen: false,
      editEvent: {},
      role: GetStoreRole(localStorage.getItem('current_store_id')),
      switchPanel: 1
    }
    this.handleDayClick = this.handleDayClick.bind(this);
    this.handleToggleAddStaffBlockOpen = this.handleToggleAddStaffBlockOpen.bind(this);
    this.handleToggleEditShiftOpen = this.handleToggleEditShiftOpen.bind(this);
    this.handleEditshiftByEvent = this.handleEditshiftByEvent.bind(this);
    this.onChangeStep = this.onChangeStep.bind(this);
    this.onChangeDepartment = this.onChangeDepartment.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.handleSelectFile = this.handleSelectFile.bind(this);

  }

  componentDidMount() {
    let { day } = this.props.match.params;
    let { department } = this.state;
    this.setState({currentDay:day})
    if (this.state.role === '2' || this.state.role === '1' || this.state.role === '5' || this.state.role === '3') {
        this.props.getDailyCostByHourDetail(day, false);
        this.props.peopleStatisticsList(day);
        this.props.getHourCostChart(day,department);
        this.props.get30MinCostChart(day, '2');
        this.props.get30MinBarCostChart(day,'0,1');
        this.props.getAccumulateCostChart(day,department);
        this.props.getAllStaff();
    } else {
      this.props.history.push('/');
    }
  }
  componentDidUpdate(){
    let { day } = this.props.match.params;
    let { department } = this.state;
    if(day !== this.state.currentDay){
      this.setState({currentDay:day})

      if (this.state.role === '2' || this.state.role === '1' || this.state.role === '5' || this.state.role === '3') {
        this.props.getDailyCostByHourDetail(day, false);
        this.props.peopleStatisticsList(day);
        this.props.getHourCostChart(day,department);
        this.props.get30MinBarCostChart(day,'0,1');
        this.props.get30MinCostChart(day,'2 ');
        this.props.getAccumulateCostChart(day,department);
      } else {
        this.props.history.push('/');
      }
    }
  }

  componentWillReceiveProps(nextProsp) {
    
    const { resources, events } = nextProsp.dailyCostByHourState;
    var costs = nextProsp.hourCostChartState;
    var costs30 = nextProsp.min30CostChartState;
    var barcosts30 = nextProsp.min30BarCostChartState;
    console.log('peopleStatisticsState', nextProsp.peopleStatisticsState);
    var peoples = nextProsp.peopleStatisticsState.dateData;
    var halfPeoples = nextProsp.peopleStatisticsState.halfData;
    var accumulateCost = nextProsp.accumulateCostChartState;
    var eventIndex = [];
    var resourceId = [];
    var formalResource = [];
    var unformalResource = [];
    let newResources = resources.map((item, index) => {
      item.textColor = 'black';
      if (item.jobTypeId === 2) {
        item.eventColor = '#FFD966';
      } else if (item.jobTypeId === 3) {
        item.eventColor = '#EA9999';
      } else if (item.jobTypeId === 7 || item.jobTypeId === 4 || item.jobTypeId === 5 || item.jobTypeId === 6 || item.jobTypeId === 21) {
        item.eventColor = '#F4CCCC';
        if(item.title.indexOf('正職') !== -1)
          item.eventColor = '#dd6363';
      } else if (item.jobTypeId === 12 || item.jobTypeId === 13 || item.jobTypeId === 14 || item.jobTypeId === 16) {
        item.eventColor = '#D9EAD3';
        if(item.title.indexOf('正職')!== -1)
          item.eventColor = '#88bd76';
        
      } else if (item.jobTypeId === 8) {
        item.eventColor = '#6FA8DC';
      } else if (item.jobTypeId === 9 || item.jobTypeId === 10) {
        item.eventColor = '#CFE2F3';
        if(item.title.indexOf('正職')!== -1)
          item.eventColor = '#75abdd';
      } else if (item.jobTypeId === 11) {
        item.eventColor = '#B6D7A8';
      } else if (item.jobTypeId === 15 || item.jobTypeId === 17 || item.jobTypeId === 18 || item.jobTypeId === 19) {
        item.eventColor = '#FFF2CC';
      }

      // if (item.title.indexOf('-') === -1) {
      //   eventIndex.push(index);
      //   resourceId.push(item.id);
      //   item.title = '本日活動';
      //   item.id = -1;
      //   item.eventColor = 'Plum';
      //   //item.eventBackgroundColor = 'Plum';
      //   //item.background = 'Plum';
      // }

      item.title = item.title.split('-')[0];

      if (item.title.indexOf('兼職') !== -1) {
        unformalResource.push(item);
      }else{
        formalResource.push(item);
      }

      return item;
    });



    if (eventIndex.length > 0) {
      for (var i = eventIndex.length - 1; i >= 0; i--) {        
        var b = newResources[eventIndex[i]];
        newResources[eventIndex[i]] = newResources[i];
        newResources[i] = b;
      }
    }

    let orderedResource = formalResource.concat(unformalResource);
    eventIndex = [];
    for (var i = orderedResource.length - 1; i >= 0; i--) {        
      if (orderedResource[i].title.indexOf('-') === -1) {
        eventIndex.push(i)
      }
    } 
    if (eventIndex.length > 0) {
      for (var i = eventIndex.length - 1; i >= 0; i--) {        
        var b = orderedResource[eventIndex[i]];
        orderedResource[eventIndex[i]] = orderedResource[i];
        orderedResource[i] = b;
      }
    }

    let newEvents = events.map((item, index) => {
      if (resourceId.indexOf(item.resourceId) != -1 && item.title.indexOf('-') === -1) {
        item.resourceId = -1;
      }
      return item;

    });


    if(newEvents.length > 0){

          if(costs30.length > 0)
            costs30.forEach(element => {
              newEvents.push({id:-1,resourceId:999,start:this.state.currentDay + 'T'+ element.time.split('-')[0],end:this.state.currentDay + 'T'+ element.time.split('-')[1],title:element.outcome.toString(),color:'Gray',textColor:'black'})
            });
          if(barcosts30.length > 0)
            barcosts30.forEach(element => {
              newEvents.push({id:-1,resourceId:998,start:this.state.currentDay + 'T'+ element.time.split('-')[0],end:this.state.currentDay + 'T'+ element.time.split('-')[1],title:element.outcome.toString(),color:'Gray',textColor:'black'})
            });
    }
    
    console.log('peoples', peoples);
    console.log('halfPeoples', halfPeoples);

    this.setState({
      resources: orderedResource,
      events: newEvents,
      costs: costs,
      peoples: peoples,
      halfPeoples: halfPeoples,
      accumulateCost: accumulateCost.expectOutcome? accumulateCost : {
        income:0.0,
        outcome:0.0,
        expectOutcome:0.0
      }
    });
    if (nextProsp.SendAPIState === 14 || nextProsp.SendAPIState === 15) {
      swal({
        type: 'warning',
        title: "該事件已簽核或有假單、加班單，無法編輯或刪除",
        showCloseButton: true,
        heightAuto: false,
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: '確定',
      }).then((result) => {
        this.props.InitAPIStatus();
      })
    }




  }
  submitForm(){
    const formData = new FormData();
    formData.append("File", this.state.selectedFile);
    API.post('Income/Daily', formData).then((response) => {
      if (response) {
        swal({
          type: 'success',
          title: '上傳成功',
          showConfirmButton: false,
          showCloseButton: true,
          heightAuto: false
        })
      }else{
        swal({
          type: 'error',
          title: '資料錯誤，請聯絡工程師。',
          showConfirmButton: false,
          showCloseButton: true,
          heightAuto: false
        })
      }
    });
  };

  handleSelectFile(event) {
    this.setState({selectedFile: event});
  }
  handleDayClick(date) {
    // if (this.state.role === '2' || this.state.role === '1' || this.state.role === '5' || this.state.role === '3') {
    //   this.props.history.push(`/adjustStaffShiftDetail/${date}`);
    // }
    
  }

  handleToggleAddStaffBlockOpen() {
    this.setState({
      isAddStaffBlockOpen: !this.state.isAddStaffBlockOpen
    });
  }

  handleDaySelect(event) {
  }

  handleToggleEditShiftOpen() {
    this.setState({
      isEditBlockOpen: !this.state.isEditBlockOpen
    });
  }

  handleEditshiftByEvent(event) {
    this.setState({
      editEvent: event,
      isEditBlockOpen: true
    });
  }
  onChangeStep(step) {
    if(this.state.step === step) return;
    this.setState({
      switchPanel: step
    })
  }
  onChangeDepartment(department) {
    let { day } = this.props.match.params;

    if(this.state.department === department.target.value) return;
    this.setState({
      department: department.target.value
    })
    if (this.state.role === '2' || this.state.role === '1' || this.state.role === '5' || this.state.role === '3') {
      this.props.getDailyCostByHourDetail(day, false);
      this.props.peopleStatisticsList(day);
      this.props.getHourCostChart(day,department.target.value);
      this.props.getAccumulateCostChart(day,department.target.value);
      this.props.getAllStaff();
  } else {
    this.props.history.push('/');
  }

  }
  render() {
    let { day } = this.props.match.params;
    let events = [...this.state.events];
    let resources = [...this.state.resources];
    var costs = [];
    var peoples = null;
    var halfPeoples = null;
    var sortedResources = [];
    //吧檯
    if(this.state.department === '-1' || this.state.department === '0')
      sortedResources.push(...resources.filter(m=>m.jobTypeId >=8 && m.jobTypeId <=10))
    //外
    if(this.state.department === '-1'|| this.state.department === '1')
      sortedResources.push(...resources.filter(m=>m.jobTypeId >=11 && m.jobTypeId <=14))
    //內
    if(this.state.department === '-1'|| this.state.department === '2')
      sortedResources.push(...resources.filter(m=>m.jobTypeId >=3 && m.jobTypeId <=7 || m.jobTypeId == 21))
    //行政
    // if(this.state.department === -1|| this.state.department === 3){
    //   sortedResources.push(...resources.filter(m=>m.jobTypeId >=15 && m.jobTypeId <=20))
    //   sortedResources.push(...resources.filter(m=>m.jobTypeId >=24 && m.jobTypeId <=31))
    // }
    //店長
    if(this.state.department === '-1'|| this.state.department === '4')
      sortedResources.push(...resources.filter(m=>m.jobTypeId ==2))
      

        // Move jobTypeId 8, 9, 10 to the end of orderedResource
    const barJobTypeIds = [8, 9, 10,2,11,12,13,14];
    const barResources = sortedResources.filter(r => barJobTypeIds.includes(r.jobTypeId));
    const otherResources = sortedResources.filter(r => !barJobTypeIds.includes(r.jobTypeId));
    sortedResources = [
      ...otherResources,
      {id:997,title:'內場\r\n人數',eventColor:'Gray',textColor:'black',jobTypeId:8},
      {id:999,title:'內場\r\n成本',eventColor:'Gray',textColor:'black',jobTypeId:8},
       ...barResources,
      {id:996,title:'外場\r\n人數',eventColor:'Gray',textColor:'black',jobTypeId:10},
      {id:998,title:'外場\r\n成本',eventColor:'Gray',textColor:'black',jobTypeId:10}
      ];

    // 找出有休假的 resourceId
    const leaveResourceIds = events
      .filter(ev => ev.title.indexOf('休假') !== -1 ||ev.title.indexOf('例假') !== -1)
      .map(ev => ev.resourceId);

    // 分成有休假和沒休假的 resource
    const leaveResources = sortedResources.filter(r => leaveResourceIds.includes(r.id));
    const ootherResources = sortedResources.filter(r => !leaveResourceIds.includes(r.id));

// 合併，把有休假的 resource 放到最後
    sortedResources = [...ootherResources, ...leaveResources];



    if(Array.isArray(this.state.costs)){
      costs = [...this.state.costs];
    }
    var startIdx = 0;
    var times = [];

    if(this.state.peoples){
      peoples = this.state.peoples;
      if(typeof peoples.time !== 'undefined' && Array.isArray(peoples.time)){
        startIdx = peoples.time.findIndex(t => t === "06:00");
        times = startIdx !== -1 ? peoples.time.slice(startIdx) : peoples.time;
      }
    }
    
    // --- 計算哪些時段的欄位應該被顯示 ---
    let visibleColumnsIndices = [];
    if (peoples && peoples.time && Array.isArray(peoples.time)) {
        const originalTimes = peoples.time;
        const originalStartIdx = peoples.time.findIndex(t => t === "06:00");
        const currentTimes = originalStartIdx !== -1 ? originalTimes.slice(originalStartIdx) : originalTimes;

        for (let i = 0; i < currentTimes.length; i++) {
            const originalIndex = originalStartIdx !== -1 ? originalStartIdx + i : i;
            let columnHasNonZeroCount = false;

            // 檢查吧檯部門的計數 (如果該部門的行可能顯示)
            const isBarDepartmentSelected = this.state.department === '-1' || this.state.department === '0';
            const isBarDataRelevant = peoples.department === 'All' || peoples.department === 'Bar';
            if (isBarDepartmentSelected && isBarDataRelevant) {
                if (peoples.barFullTimeCount[originalIndex] !== 0 || peoples.barPartTimeCount[originalIndex] !== 0) {
                    columnHasNonZeroCount = true;
                }
            }

            // 檢查外場部門的計數 (如果該部門的行可能顯示)
            const isOutfieldDepartmentSelected = this.state.department === '-1' || this.state.department === '1';
            const isOutfieldDataRelevant = peoples.department === 'All' || peoples.department === 'Outfield';
            if (isOutfieldDepartmentSelected && isOutfieldDataRelevant) {
                if (peoples.outfieldFullTimeCount[originalIndex] !== 0 || peoples.outfieldPartTimeCount[originalIndex] !== 0) {
                    columnHasNonZeroCount = true;
                }
            }

            // 檢查內場部門的計數 (如果該部門的行可能顯示)
            const isInfieldDepartmentSelected = this.state.department === '-1' || this.state.department === '2';
            const isInfieldDataRelevant = peoples.department === 'All' || peoples.department === 'Infield';
            if (isInfieldDepartmentSelected && isInfieldDataRelevant) {
                if (peoples.infieldFullTimeCount[originalIndex] !== 0 || peoples.infieldPartTimeCount[originalIndex] !== 0) {
                    columnHasNonZeroCount = true;
                }
            }

            // 檢查行政部門的計數 (如果該部門的行可能顯示)
            const isAdminDepartmentSelected = this.state.department === '-1' || this.state.department === '4';
            const isAdminDataRelevant = peoples.department === 'All'; // 行政部門的行只在 peoples.department 為 'All' 時顯示
            if (isAdminDepartmentSelected && isAdminDataRelevant) {
                if (peoples.administrationFullTimeCount[originalIndex] !== 0) {
                    columnHasNonZeroCount = true;
                }
            }

            if (columnHasNonZeroCount) {
                visibleColumnsIndices.push(i);
            }
        }
    }
    // --- 結束計算哪些時段的欄位應該被顯示 ---

    // --- 新增：判斷每個數據行是否應該顯示 ---
    // 輔助函數：檢查一個數據陣列在可見欄位中是否有非零值
    const getRowContentVisibility = (dataArray) => {
        // 確保 dataArray 存在且是陣列
        if (!dataArray || !Array.isArray(dataArray)) return false;
        
        const filteredData = dataArray.slice(startIdx).filter((_, index) => visibleColumnsIndices.includes(index));
        return filteredData.some(item => item !== 0);
    };

    // 吧檯部門的行可見性判斷
    const isBarDepartmentSelected = this.state.department === '-1' || this.state.department === '0';
    const isBarDataRelevant = peoples.department === 'All' || peoples.department === 'Bar';
    const showBarFullTimeRow = isBarDepartmentSelected && isBarDataRelevant && getRowContentVisibility(peoples.barFullTimeCount);
    const showBarPartTimeRow = isBarDepartmentSelected && isBarDataRelevant && getRowContentVisibility(peoples.barPartTimeCount);

    let barRowSpan = 0;
    if (showBarFullTimeRow) barRowSpan++;
    if (showBarPartTimeRow) barRowSpan++;
    const showBarDepartmentBlock = barRowSpan > 0; // 只要有任何子行可見，就顯示整個部門區塊

    // 外場部門的行可見性判斷
    const isOutfieldDepartmentSelected = this.state.department === '-1' || this.state.department === '1';
    const isOutfieldDataRelevant = peoples.department === 'All' || peoples.department === 'Outfield';
    const showOutfieldFullTimeRow = isOutfieldDepartmentSelected && isOutfieldDataRelevant && getRowContentVisibility(peoples.outfieldFullTimeCount);
    const showOutfieldPartTimeRow = isOutfieldDepartmentSelected && isOutfieldDataRelevant && getRowContentVisibility(peoples.outfieldPartTimeCount);

    let outfieldRowSpan = 0;
    if (showOutfieldFullTimeRow) outfieldRowSpan++;
    if (showOutfieldPartTimeRow) outfieldRowSpan++;
    const showOutfieldDepartmentBlock = outfieldRowSpan > 0;

    // 內場部門的行可見性判斷
    const isInfieldDepartmentSelected = this.state.department === '-1' || this.state.department === '2';
    const isInfieldDataRelevant = peoples.department === 'All' || peoples.department === 'Infield';
    const showInfieldFullTimeRow = isInfieldDepartmentSelected && isInfieldDataRelevant && getRowContentVisibility(peoples.infieldFullTimeCount);
    const showInfieldPartTimeRow = isInfieldDepartmentSelected && isInfieldDataRelevant && getRowContentVisibility(peoples.infieldPartTimeCount);

    let infieldRowSpan = 0;
    if (showInfieldFullTimeRow) infieldRowSpan++;
    if (showInfieldPartTimeRow) infieldRowSpan++;
    const showInfieldDepartmentBlock = infieldRowSpan > 0;

    // 行政部門的行可見性判斷
    const isAdminDepartmentSelected = this.state.department === '-1' || this.state.department === '4';
    const isAdminDataRelevant = peoples.department === 'All';
    const showAdministrationFullTimeRow = isAdminDepartmentSelected && isAdminDataRelevant && getRowContentVisibility(peoples.administrationFullTimeCount);
    const showAdministrationDepartmentBlock = showAdministrationFullTimeRow; // 行政部門只有一行

    // --- 結束新增判斷邏輯 ---
    
    console.log('halfPeoples1', this.state.halfPeoples);
    if(this.state.halfPeoples && typeof this.state.halfPeoples !== 'undefined' && Array.isArray(this.state.halfPeoples.time)){
      halfPeoples =  {...this.state.halfPeoples} ;
        console.log('halfPeoples2' );

      if(typeof halfPeoples.time !== 'undefined'){
        console.log('halfPeoples3' );

        halfPeoples.time.forEach((element, index) => {

        var barTotal = halfPeoples.barFullTimeCount[index]+halfPeoples.barManagementCount[index]+halfPeoples.barPartTimeCount[index]+halfPeoples.outfieldFullTimeCount[index]+halfPeoples.outfieldManagementCount[index]+halfPeoples.outfieldPartTimeCount[index];
        events.push({
          id:-1,
          resourceId:996,
          start:this.state.currentDay + 'T'+ element, 
          end:this.state.currentDay + 'T'+ halfPeoples.time[index+1],
          title: barTotal.toString(),
          color:'Gray',
          textColor:'black'})

        var otherTotal = halfPeoples.infieldFullTimeCount[index]+halfPeoples.infieldManagementCount[index]+halfPeoples.infieldPartTimeCount[index];
        events.push({
          id:-1,
          resourceId:997,
          start:this.state.currentDay + 'T'+ element, 
          end:this.state.currentDay + 'T'+ halfPeoples.time[index+1],
          title: (otherTotal).toString(),
          color:'Gray',
          textColor:'black'})
      });
      }
      
    }


    return (
      <div className="p-editShift">
        <div className="u-block">
          <div style={{ display: this.state.switchPanel === 2 ? 'block' : 'block'}}>
            <div className="u-title">{day}每小時收支
            
            <select style={{float:'right'}} onChange={this.onChangeDepartment}>
              <option value={'-1'}>
                全部
              </option>
              <option value={'0,1,2'}>
                吧檯+外場+內場
              </option>
              <option value={'0'}>
                吧檯
              </option>
              <option value={'1'}>
                外場
              </option>
              <option value={'2'}>
                內場
              </option>
              <option value={'3'}>
                行政
              </option> 
              <option value={'4'}>
                店長
              </option>
            </select>
            </div>
            <form style={{display:localStorage.getItem('username') === '22'?'block':'none'}}>

<FileUploader
  onFileSelectSuccess={this.handleSelectFile}
  onFileSelectError={({ error }) => alert(error)}
/>
  <button type='button' onClick={this.submitForm}>上傳</button>
</form>
            <HourCostChart date={day} data={costs} accumulateCost={this.state.accumulateCost} department={this.state.department}/>
            
          </div>

          <div style={{ display: this.state.switchPanel === 1 ? 'block' : 'block'}}>
            <div className="u-title m-t-16">工作人員當日打卡紀錄            
            </div>

            <div className="u-notice">※此紀錄為實際打卡紀錄，未簽核也會顯示，未簽退不顯示。</div>
            <div className="change-day-div">             

              <button type="button" className="fc-promptResource-button fc-button fc-state-default fc-corner-left fc-corner-right" onClick={
                  (event) => { 
                    var tommorrow = moment(day, "YYYY-MM-DD").add(-1,'days').format("YYYY-MM-DD").toString();
                  this.props.history.push(`/dailyCostByHour/` + tommorrow);
                  window.location.assign("/dailyCostByHour/"+tommorrow);
                }
              }>
                前一天
              </button>
              <button type="button" className="fc-promptResource-button fc-button fc-state-default fc-corner-left fc-corner-right" onClick={
                  (event) => { 
                    var tommorrow = moment(day, "YYYY-MM-DD").add(1,'days').format("YYYY-MM-DD").toString();
                  this.props.history.push(`/dailyCostByHour/` + tommorrow);
                  window.location.assign("/dailyCostByHour/"+tommorrow);
                }
              }>
                下一天
              </button>
            </div>

                  <div className="p-editShift__calendar" style={{top:'20px'}}>
                    <Calendar {...this.state.calendarConfig}
                      events={events}
                      resources={sortedResources}
                      defaultDate={day}
                      btnDisplay={false}
                      startTime={day}
                    />
                  </div>

          </div>
          {
          peoples.time?
            <div className="u-table-responsive" style={{paddingTop:'50px'}}>
                          <div className="u-title m-t-16">預期彙整人數表      
            </div>
          <table className="u-table u-table-border">
            <thead>
              <tr>
                <th></th>
                {
                  // 只顯示06:00之後且有非零計數的時段
                  times.filter((_, index) => visibleColumnsIndices.includes(index)).map((item, index) => <th key={index}>{item}</th>)
                }
              </tr>
            </thead>
            <tbody>
              {/* 吧檯部門 */}
              {showBarDepartmentBlock && (
                <>
                  {showBarFullTimeRow && (
                    <tr >
                      <td rowSpan={barRowSpan} className="barfield">吧檯</td>
                      {
                        peoples.barFullTimeCount.slice(startIdx)
                          .filter((_, index) => visibleColumnsIndices.includes(index)) // 過濾數據
                          .map( (item,index) => <td key={index} className="barfield-formal">正職：{item}</td>)
                      }
                    </tr>
                  )}
                  {showBarPartTimeRow && (
                    <tr >
                      {!showBarFullTimeRow && <td rowSpan={barRowSpan} className="barfield">吧檯</td>} {/* 如果正職行被隱藏，則在此行顯示 rowSpan td */}
                      {
                        peoples.barPartTimeCount.slice(startIdx)
                          .filter((_, index) => visibleColumnsIndices.includes(index)) // 過濾數據
                          .map( (item,index) => <td key={index} className="barfield">兼職：{item}</td>)
                      }
                    </tr>
                  )}
                </>
              )}
                            {/* 外場部門 */}
              {showOutfieldDepartmentBlock && (
                <>
                  {showOutfieldFullTimeRow && (
                    <tr >
                      <td rowSpan={outfieldRowSpan} className="outfield">外場</td>
                      {
                        peoples.outfieldFullTimeCount.slice(startIdx)
                          .filter((_, index) => visibleColumnsIndices.includes(index)) // 過濾數據
                          .map( (item,index) => <td key={index} className="outfield-formal">正職：{item}</td>)
                      }
                    </tr>
                  )}
                  {showOutfieldPartTimeRow && (
                    <tr >
                      {!showOutfieldFullTimeRow && <td rowSpan={outfieldRowSpan} className="outfield">外場</td>} {/* 如果正職行被隱藏，則在此行顯示 rowSpan td */}
                      {
                        peoples.outfieldPartTimeCount.slice(startIdx)
                          .filter((_, index) => visibleColumnsIndices.includes(index)) // 過濾數據
                          .map( (item,index) => <td key={index} className="outfield">兼職：{item}</td>)
                      }
                    </tr>
                  )}
                </>
              )}
                            {/* 內場部門 */}
              {showInfieldDepartmentBlock && (
                <>
                  {showInfieldFullTimeRow && (
                    <tr >
                      <td rowSpan={infieldRowSpan} className="infield">內場</td>
                      {
                        peoples.infieldFullTimeCount.slice(startIdx)
                          .filter((_, index) => visibleColumnsIndices.includes(index)) // 過濾數據
                          .map( (item,index) => <td key={index} className="infield-formal">正職：{item}</td>)
                      }
                    </tr>
                  )}
                  {showInfieldPartTimeRow && (
                    <tr >
                      {!showInfieldFullTimeRow && <td rowSpan={infieldRowSpan} className="infield">內場</td>} {/* 如果正職行被隱藏，則在此行顯示 rowSpan td */}
                      {
                        peoples.infieldPartTimeCount.slice(startIdx)
                          .filter((_, index) => visibleColumnsIndices.includes(index)) // 過濾數據
                          .map( (item,index) => <td key={index} className="infield">兼職：{item}</td>)
                      }
                    </tr>
                  )}
                </>
              )}
                            {/* 行政部門 */}
              {showAdministrationDepartmentBlock && (
                <tr >
                  <td rowSpan="1" className="adminfield">行政部門</td> {/* 修正：行政部門只有一列數據，rowSpan 應為 1 */}
                  {
                    peoples.administrationFullTimeCount.slice(startIdx)
                      .filter((_, index) => visibleColumnsIndices.includes(index)) // 過濾數據
                      .map( (item,index) => <td key={index} className="adminfield">行政：{item}</td>)
                  }
                </tr>
              )}
            </tbody>
          </table>
        </div>
            :''
          }
          
        </div>

      </div>
    )
  }
}

const mapStateToProps = (store) => ({
  SendAPIState: store.SendAPIStatusState,
  dailyCostByHourState: store.dailyCostByHourState,
  hourCostChartState: store.hourCostChartState,
  min30CostChartState: store.min30CostChartState,
  min30BarCostChartState: store.min30BarCostChartState,
  peopleStatisticsState: store.PeopleStatisticsState,
  allStaffListInAdjustState: store.allStaffListInAdjustState,
  accumulateCostChartState: store.AccumulateCostChartState
})

export default connect(mapStateToProps,{
    getDailyCostByHourDetail,
    getHourCostChart,
    get30MinCostChart,
    get30MinBarCostChart,
    getAccumulateCostChart,
    getAllStaff,
    peopleStatisticsList,
  InitAPIStatus,
})(withRouter(DailyCostByHour));